import { FaroRoutes } from "@grafana/faro-react";
import type React from "react";
import { useEffect, useState } from "react";
import { Routes } from "react-router-dom";

interface AppRoutesProps {
	children: React.ReactNode;
}

export const AppRoutes: React.FC<AppRoutesProps> = ({ children }) => {
	const [useFaro, setUseFaro] = useState(() => {
		const faroUrl = process.env.BUN_PUBLIC_FARO_URL;
		const hasConsent =
			typeof localStorage !== "undefined" &&
			localStorage.getItem("adafia-consent") === "granted";
		return !!(faroUrl && hasConsent);
	});

	useEffect(() => {
		const handleConsent = () => {
			setUseFaro(true);
		};
		window.addEventListener("adafia-consent-granted", handleConsent);
		return () => {
			window.removeEventListener("adafia-consent-granted", handleConsent);
		};
	}, []);

	if (useFaro) {
		return <FaroRoutes>{children}</FaroRoutes>;
	}
	return <Routes>{children}</Routes>;
};
